import { connect } from 'react-redux';
import { get } from 'lodash';

import { setMinEndTime } from '../utils';
import { TIME_PARAM_FORMAT } from 'eventbrite_design_system/utils/time';

const mapFormValuesToProps = (formState, { prefix = '' }) => {
    const formValues = formState.values || {};

    // Use _.get to deal with object prefix keys with arrays e.g. `a[0].lolcats`
    const startDate = get(formValues, `${prefix}startDate`);
    const endDate = get(formValues, `${prefix}endDate`);
    const startTime = get(formValues, `${prefix}startTime`);
    const duration = get(formValues, `${prefix}duration`);

    let minTime = '00:00';

    if (startDate && startTime) {
        if (endDate === startDate || !endDate) {
            minTime = setMinEndTime(startDate, startTime, duration).format(
                TIME_PARAM_FORMAT,
            );
        }
    }

    return {
        minTime,
    };
};

const endTimeConnector = (component, getFormState, options = {}) =>
    connect((state) => mapFormValuesToProps(getFormState(state), options))(
        component,
    );

export default endTimeConnector;
